module.exports = __webpack_public_path__ + "img/banner_edu_01.d686a342.jpg";